import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/collection/Green%20Forest") {
      return;
    }
    window.scrollTo(0, 0);
    // console.log(pathname);
  }, [pathname]);

  return null;
}
